export function sortSearch(params) {
  const { sortOrder, searchTerm, drinks, category, booze } = params

  if (!drinks) {
    return []
  }

  const normalizeText = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()

  const flattenText = (value) => {
    if (Array.isArray(value)) {
      return value.map(flattenText).join(' ')
    }

    if (value && typeof value === 'object') {
      return Object.values(value).map(flattenText).join(' ')
    }

    return String(value || '')
  }

  const drinkSearchText = (drink) =>
    normalizeText(
      [
        drink.title,
        drink.ingredients,
        drink.components,
        drink.instructions,
        drink.backstory,
        drink.subs,
        drink.tags,
        drink.category,
      ]
        .map(flattenText)
        .join(' '),
    )

  let filteredData = [...drinks]

  // Filter by category first - defaults to all drinks
  if (category === 'ASH') {
    filteredData = filteredData.filter((drink) => Boolean(drink.ashleyfav))
  } else if (category === 'HOUSE') {
    filteredData = filteredData.filter((drink) => Boolean(drink.housefav))
  } else if (category === 'DOG') {
    filteredData = filteredData.filter((drink) =>
      normalizeText(flattenText(drink.category)).includes('irresistibulls'),
    )
  }

  // Limit by booze types. Multiple selections are treated as "any selected".
  const selectedBooze = Object.values(booze || {})
    .filter((item) => item.variant === 'contained')
    .map((item) => normalizeText(item.key))

  if (selectedBooze.length > 0) {
    filteredData = filteredData.filter((drink) => {
      const boozeSearchText = normalizeText(
        [drink.ingredients, drink.components, drink.tags, drink.category]
          .map(flattenText)
          .join(' '),
      )

      return selectedBooze.some((selected) =>
        boozeSearchText.includes(selected),
      )
    })
  }

  // Apply search criteria
  const searchTokens = normalizeText(searchTerm).split(/\s+/).filter(Boolean)
  const searchedData =
    searchTokens.length > 0
      ? filteredData.filter((drink) => {
          const text = drinkSearchText(drink)
          return searchTokens.every((token) => text.includes(token))
        })
      : filteredData

  // Sort data if data present - default sort is by date created
  if (sortOrder === 'AZ') {
    return [...searchedData].sort((a, b) => a.title.localeCompare(b.title))
  }

  if (sortOrder === 'ZA') {
    return [...searchedData].sort((a, b) => b.title.localeCompare(a.title))
  }

  if (sortOrder === 'RANDOM') {
    return [...searchedData].sort(() => Math.random() - 0.5)
  }

  return [...searchedData].sort((a, b) => b.created.localeCompare(a.created))
}
